export var CSS_PREFIX = 'asyncapi';
export var CONTENT_TYPES_SITE = 'https://www.iana.org/assignments/media-types';
export var COLLAPSE_ALL_TEXT = 'Collapse All';
export var EXPAND_ALL_TEXT = 'Expand All';
export var VALIDATION_ERRORS_TYPE = 'https://github.com/asyncapi/parser-js/validation-errors';
export var SERVERS = 'Servers';
export var ONE_OF_PAYLOADS_TEXT = 'One of those payloads:';
export var ANY_OF_PAYLOADS_TEXT = 'Any of those payloads:';
export var GENERATED_BADGE_TEXT = 'generated';
export var ONE_OF_FOLLOWING_MESSAGES_PUBLISH_TEXT = 'You can send one of the following messages:';
export var ONE_OF_FOLLOWING_MESSAGES_PUBLISH_SINGLE_TEXT = 'You can send the following message:';
export var ONE_OF_FOLLOWING_MESSAGES_SUBSCRIBE_TEXT = 'You can subscribe to one of the following messages:';
export var ONE_OF_FOLLOWING_MESSAGES_SUBSCRIBE_SINGLE_TEXT = 'You can subscribe to the following message:';
export var CONTACT_TEXT = 'Contact';
export var NAM_TEXTE = 'Name';
export var URL_TEXT = 'Url';
export var EMAIL_TEXT = 'Email';
export var LICENSE_TEXT = 'License';
export var TERMS_OF_SERVICE_TEXT = 'Terms of service';
export var URL_SUPPORT_TEXT = 'Support';
export var EMAIL_SUPPORT_TEXT = 'Email support';
export var LOCATION_TEXT = 'Location';
export var TYPE_TEXT = 'Type';
export var SPECIFICATION_TEXT = 'Specification';
export var DEPRECATED_TEXT = 'Deprecated';
export var PUBLISH_TEXT = 'Publish';
export var SUBSCRIBE_TEXT = 'Subscribe';
export var REQUIRED_TEXT = 'Required';
export var GENERATED_TEXT = 'Generated';
export var MESSAGES_TEXT = 'Messages';
export var SCHEMAS_TEXT = 'Schemas';
export var MESSAGE_TEXT = 'Message';
export var CHANNELS_TEXT = 'Channels';
export var PARAMETERS_TEXT = 'Parameters';
export var HEADERS_TEXT = 'Headers';
export var MESSAGE_HEADERS_TEXT = 'Message Headers';
export var HEADERS_EXAMPLE_TEXT = 'Example of headers';
export var TAGS_TEXT = 'Tags';
export var PAYLOAD_TEXT = 'Payload';
export var MESSAGE_PAYLOAD_TEXT = 'Message Payload';
export var PAYLOAD_EXAMPLE_TEXT = 'Example of payload';
export var SCHEMA_EXAMPLE_TEXT = 'Example';
export var NONE_TEXT = 'None';
export var ANY_TEXT = 'Any';
export var ERROR_TEXT = 'Error';
export var EXPAND_ERROR_BUTTON_TEXT = 'Expand';
export var COLLAPSE_ERROR_BUTTON_TEXT = 'Collapse';
export var SECURITY_TEXT = 'Security';
export var URL_VARIABLES_TEXT = 'URL Variables';
export var FLOWS_TEXTS = {
    FLOW: 'Flow',
    AUTHORIZATION_URL: 'Authorization URL',
    TOKEN_URL: 'Token URL',
    REFRESH_URL: 'Refresh URL',
    SCOPES: 'Scopes',
};
export var SECURITY_COLUMNS_NAMES = [
    'Type',
    'Stage',
    'In',
    'Name',
    'Scheme',
    'Format',
    'Description',
];
export var SERVER_COLUMN_NAMES = [
    'URL',
    'Default',
    'Possible values',
    'Description',
];
export var SERVER_SECURITY_COLUMN_NAMES = [
    'Type',
    'Bearer format',
    'In',
    'Scheme',
    'Header',
    'Description',
];
export var SCHEMA_COLUMN_NAMES = [
    'Name',
    'Title',
    'Type',
    'Format',
    'Default',
    'Description',
];
export var SERVER_VARIABLES_COLUMN_NAMES = [
    'Name',
    'Default value',
    'Possible values',
    'Description',
];
export var CONTAINER_LABELS;
(function (CONTAINER_LABELS) {
    CONTAINER_LABELS["INFO"] = "info";
    CONTAINER_LABELS["CHANNELS"] = "channels";
    CONTAINER_LABELS["SERVERS"] = "servers";
    CONTAINER_LABELS["MESSAGES"] = "messages";
    CONTAINER_LABELS["SCHEMAS"] = "schemas";
})(CONTAINER_LABELS || (CONTAINER_LABELS = {}));
export var CONTAINER_LABELS_VALUES = Object.values(CONTAINER_LABELS);
export var ITEM_LABELS;
(function (ITEM_LABELS) {
    ITEM_LABELS["CHANNEL"] = "channel";
    ITEM_LABELS["SERVER"] = "server";
    ITEM_LABELS["MESSAGE"] = "message";
    ITEM_LABELS["SCHEMA"] = "schema";
})(ITEM_LABELS || (ITEM_LABELS = {}));
export var ITEM_LABELS_VALUES = Object.values(ITEM_LABELS);
//# sourceMappingURL=constants.js.map